<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/ckeditor4.png" /></div>
      <p>CKEditor4</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = 'https://uedcdn.zto.com/static/ckeditor/'
export default {
  name: 'index',
  data() {
    return {
      fileList: [{
        label: '4.13.0',
        linkList: [
          ur + '4.13.0/basic/ckeditor.js',
          ur + '4.13.0/standard/ckeditor.js',
          ur + '4.13.0/full/ckeditor.js',
          ur + '4.13.0/tank/ckeditor.js',
          ur + '4.13.0/baseConfig.js'
        ]
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/ListCKEditor4.vue